// TwoTwoFiveSeven.jsx
'use strict';
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import Trans from '../component/Trans.jsx';
import MailTo from '../container/MailTo.js';
import preventPullToRefresh from '../resource/preventPullToRefresh.js';
import { TranslationNamespace } from '../resource/translationNamespace.js';
import BackIconSource from '../../img/ic_topbar_back.svg';

class TwoTwoFiveSeven extends React.PureComponent {
  componentDidMount() {
    this.unsubscribe = preventPullToRefresh('body');
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  render() {
    const { goBack, t } = this.props;
    return (
      <StyledTwoTwoFiveSeven>
        <Header>
          <CloseButton onClick={() => goBack()} role="button">
            <CloseIcon src={BackIconSource} title="close" />
          </CloseButton>
          <HeaderTitle>2257</HeaderTitle>
        </Header>
        <Body>
          <BodyTitle>
            {t('2257_title', {
              ns: TranslationNamespace.SETTINGS,
            })}
          </BodyTitle>
          <TextBlock>
            <Trans
              defaults={t('2257_p1', {
                ...['mailHref placeHolder'],
                ns: TranslationNamespace.SETTINGS,
              }).replace('mailHref placeHolder', '<0>{mail}</0>')}
              values={{ mail: 'support@swag.live' }}
              components={[
                <TextAnchor
                  forwardedAs="a"
                  key="support@swag.live"
                  title="Email: support@swag.live"
                >
                  support@swag.live
                </TextAnchor>,
              ]}
            />
          </TextBlock>
          <TextBlock>
            {t('2257_p2', {
              ns: TranslationNamespace.SETTINGS,
            })}
          </TextBlock>
        </Body>
      </StyledTwoTwoFiveSeven>
    );
  }
}

TwoTwoFiveSeven.propTypes = {
  goBack: PropTypes.func.isRequired,
  t: PropTypes.func,
};

TwoTwoFiveSeven.defaultProps = {
  t: () => null,
};

const StyledTwoTwoFiveSeven = styled.div`
  margin-top: var(--space-to-pinned-notification);
`;

const Header = styled.div`
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;
  border-bottom: 1px solid rgb(100, 100, 100, 0.5);
  height: 58px;
  background-color: #232323;
`;

const CloseButton = styled.button`
  position: absolute;
  left: 0;
  border: 0;
  padding: 14px 16px;
  background: none;
  cursor: pointer;
  outline: 0;
  :hover {
    opacity: 0.7;
  }
`;

const CloseIcon = styled.img`
  width: 30px;
  height: 30px;
  vertical-align: top;
`;

const HeaderTitle = styled.div`
  margin: 0px;
  font-size: 16px;
  color: #ffffff;
`;

const Body = styled.div`
  border-bottom: 1px solid rgb(100, 100, 100, 0.5);
  border-top: 1px solid rgb(100, 100, 100, 0.5);
  padding: 30px 16px;
  background-color: #232323;
  overflow: hidden;
`;

const BodyTitle = styled.div`
  margin-bottom: 16px;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.43;
  color: #00d2be;
`;

const TextBlock = styled.div`
  margin-bottom: 4px;
  font-size: 14px;
  line-height: 1.43;
  color: #ffffff;
`;

const TextAnchor = styled(MailTo)`
  color: #00d2be;
  text-decoration: underline;
`;

export default withTranslation()(TwoTwoFiveSeven);
